import { COUPON_CONSTANTS } from "../constants/couponConstants";

export const fetchCouponsAction = (params) => ({
  type: COUPON_CONSTANTS.FETCH_COUPONS_REQUEST,
  payload: params,
});

export const fetchCouponUsersAction = (params) => ({
  type: COUPON_CONSTANTS.FETCH_COUPON_USERS_REQUEST,
  payload: params,
});
